import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CacheService } from "@delon/cache";
import { NzModalRef } from "ng-zorro-antd/modal";

interface Option {
  label: string;
  value: any;
}

@Component({
  selector: "host-house-picker-v3_4",
  templateUrl: "./house-picker-v3_4.component.html",
  styleUrls: ["./house-picker-v3_4.component.scss"],
})
export class HousePickerComponent_v3_4 implements OnInit {
  listOfGroupOption: Option[] = [];
  listOfHouseTypeOption: Option[] = [];
  listOfTagOption: Option[] = [];
  // filterOptions = [
  //   {
  //     list: this.listOfGroupOption,
  //     extra: { label: '不限分组', value: null },
  //     selected: (value) => value === this.groupId,
  //     onSelect: (value) => {
  //       this.groupId = value;
  //       this.fetchHouseList();
  //     }
  //   },
  //   {
  //     list: this.listOfHouseTypeOption,
  //     extra: { label: '不限房型', value: null },
  //     selected: (value) => value === this.houseTypeId,
  //     onSelect: (value) => {
  //       this.houseTypeId = value;
  //       this.fetchHouseList();
  //     }
  //   },
  //   {
  //     list: this.listOfTagOption,
  //     extra: { label: '不限标签', value: null },
  //     selected: (value) => value === this.tagId,
  //     onSelect: (value) => {
  //       this.tagId = value;
  //       this.fetchHouseList();
  //     }
  //   },
  // ];
  // filter
  groupId = null;
  typeId = null;
  tagId = null;

  listOfHouse;
  @Input() selectedHouses = new Set();
  @Input() filteredHouses = [];
  @Input() mode: "single" | "multiple" = "multiple";
  /// 是否发射值
  /// 作为普通组件，该值需设置true；作为modal组件，该值为false，modal组件有其独有的传值方式
  @Input() emitValue = false;
  @Output() onChange = new EventEmitter<Option[]>();

  constructor(
    private cacheSrv: CacheService,
    private http: HttpClient,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit() {
    this.fetchGroupList();
    this.fetchHouseTypeList();
    this.fetchTagList();

    this.fetchHouseList();
  }

  private fetchGroupList() {
    return this.cacheSrv
      .get("/api/house_group/group_list", { mode: "promise", type: "m", expire: 1 * 60 })
      .subscribe((rst: any) => {
        const list = rst?.data?.list ?? [];
        this.listOfGroupOption = list.map((item) => ({
          label: item.name,
          value: item.group_id,
        }));
      });
  }

  private fetchHouseTypeList() {
    return this.cacheSrv
      .get("/api/house_type/all", { mode: "promise", type: "m", expire: 1 * 60 })
      .subscribe((rst: any) => {
        const list = rst?.data?.list ?? [];
        this.listOfHouseTypeOption = list.map((item) => ({
          label: item.title,
          value: item.id,
        }));
      });
  }

  private fetchTagList() {
    return this.cacheSrv
      .get("/api/house_status_setting/get", { mode: "promise", type: "m", expire: 1 * 60 })
      .subscribe((rst: any) => {
        const list = rst?.data?.house_tag ?? [];
        this.listOfTagOption = list.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      });
  }

  private fetchHouseList() {
    const params = {
      page: 1,
      page_size: 1000,
      format: "batch_set_available",
      group_id: this.groupId,
      house_type_id: this.typeId,
      house_tag_id: this.tagId,
    };
    return this.http.get("/api/reservation/house_list", { params }).subscribe((rst: any) => {
      this.listOfHouse = rst?.data?.list ?? [];

      if (this.filteredHouses.length) {
        this.listOfHouse = this.listOfHouse
          .map((h) => ({
            ...h,
            houses: h.houses.filter((hh) => !this.filteredHouses.includes(hh.house_id)),
          }))
          .filter((h) => h.houses.length);
      }

      if ((this.groupId || this.typeId || this.tagId) && this.mode === "multiple") {
        this.onSelectAll();
      }
    });
  }

  onSelect(houseId) {
    if (this.selectedHouses.has(houseId)) {
      this.selectedHouses.delete(houseId);
    } else {
      if (this.mode === "single") {
        this.selectedHouses.clear();
      }

      this.selectedHouses.add(houseId);
    }
  }

  onSelectAll() {
    const houses = this.listOfHouse.flatMap((h) => h.houses).map((h) => h.house_id);
    this.selectedHouses = new Set(houses);
  }

  onFilter(type: "group" | "type" | "tag", value: number) {
    if (type === "group") {
      this.groupId = value;
    } else if (type === "type") {
      this.typeId = value;
    } else if (type === "tag") {
      this.tagId = value;
    }

    this.selectedHouses.clear();
    this.fetchHouseList();
  }

  onConfirm() {
    const ids = Array.from(this.selectedHouses);
    const selectedHouses = this.listOfHouse
      .flatMap((h) => h.houses)
      .filter((h) => ids.includes(h.house_id))
      .map((h) => ({ label: h.house_title, value: h.house_id }));
    /** 兼容组件和modal组件两种方式 */
    console.log("this.modalref: ", this.modalRef);

    if (this.emitValue) {
      this.onChange.emit(selectedHouses);
    } else {
      this.modalRef?.destroy({
        type: "ok",
        data: selectedHouses,
      });
    }
  }

  onCancel() {
    this.modalRef.destroy();
  }
}
